module.exports = __webpack_public_path__ + "img/code.4e11a589.gif";